module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_retail-81db2c2969c6c8e29ac84659feb0bad0.svg";